export default "__VITE_ASSET__6eb8fa67__"